import React, { useEffect, useRef, useState } from "react";
import Tooltip from "../../components/tooltip";
import { ReaderNotificationCustomDNS } from "./ReaderNotificationCustomDNS";
import I18n from "i18n";

interface Props {
  senderNameLabel: string;
  emailLabel: string;
  emailValue: string;
  senderValue: string;
  fromEmailStatus?: "none" | "new" | "checking" | "verified" | "active" | null;
  onEmailChange: (value: string) => void;
  onSenderChange: (value: string) => void;
  onBlur: () => void;
  onKeyPress: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  isFromEmail?: boolean;
  dnsText?: string;
  onDnsStatusCheck?: () => void;
  onDeleteEmailSettings?: () => void;
}

export function ReaderNotificationConfigEmailForm({
  senderNameLabel,
  emailLabel,
  emailValue,
  senderValue,
  fromEmailStatus,
  onEmailChange,
  onSenderChange,
  onBlur,
  onKeyPress,
  isFromEmail,
  dnsText,
  onDnsStatusCheck,
  onDeleteEmailSettings,
}: Props) {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleOptionClick = (callback?: () => void) => {
    setShowDropdown(false);
    if (callback) callback();
  };
  const emailIconMap = {
    new: {
      icon: <i className="icon-arrow-up"></i>,
      tooltip: I18n.t(
        "webapp.reader_admin.edit.notification_configuration.sender.status_new"
      ),
    },
    checking: {
      icon: <i className="legacy-icon-recover-dark"></i>,
      tooltip: I18n.t(
        "webapp.reader_admin.edit.notification_configuration.sender.status_checking"
      ),
    },
    verified: {
      icon: <i className="legacy-icon-ok-dark"></i>,
      tooltip: I18n.t(
        "webapp.reader_admin.edit.notification_configuration.sender.status_verified"
      ),
    },
    active: {
      icon: <i className="icon-dot-filled" style={{ color: "#99BB33" }}></i>,
      tooltip: I18n.t(
        "webapp.reader_admin.edit.notification_configuration.sender.status_active"
      ),
    },
  };

  const emailIcon = fromEmailStatus && fromEmailStatus !== "none" ? emailIconMap[fromEmailStatus] : null;

  return (
    <div className="row">
      <div className="col1of2">
        <div className="form-item--inline mbs" style={{ width: "80%" }}>
          <label className="form-item__label">{senderNameLabel}</label>
          <input
            type="text"
            className="text-input text-input--block"
            value={senderValue}
            onChange={(e) => onSenderChange(e.target.value)}
            onBlur={onBlur}
            onKeyDown={onKeyPress}
          />
        </div>
      </div>
      <div className="col1of2">
        <div className="form-item--inline mbs" style={{ width: "80%" }}>
          <label className="form-item__label">{emailLabel}</label>
          <div style={{ position: "relative" }}>
            <div className="form-item__input" style={{ flexGrow: 1 }}>
              <input
                type="email"
                className="text-input text-input--block"
                value={emailValue}
                onChange={(e) => onEmailChange(e.target.value)}
                onBlur={onBlur}
                onKeyDown={onKeyPress}
              />
              {emailIcon && isFromEmail && (
                <span>
                  <Tooltip tooltipBody={emailIcon.tooltip}>
                    {emailIcon.icon}
                  </Tooltip>
                </span>
              )}
            </div>
            {isFromEmail && (
              <div
                ref={dropdownRef}
                style={{ position: "absolute", top: "10%", left: "100%" }}
              >
                <span
                  style={{ marginLeft: "10px", position: "relative" }}
                  onClick={() => {
                    setShowDropdown(!showDropdown);
                  }}
                >
                  <i className="legacy-icon-edit-dark"></i>
                </span>
                {showDropdown && (
                  <ReaderNotificationCustomDNS
                    status={fromEmailStatus ?? null}
                    onDnsStatusCheck={onDnsStatusCheck}
                    onDeleteEmailSettings={onDeleteEmailSettings}
                    handleOptionClick={handleOptionClick}
                    dnsText={dnsText}
                    domain={emailValue?.split("@")[1]}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
